import { useRecoilState } from 'recoil';

import { TypewriterText } from './TypewriterText';
import { animatingThreadIdState } from './animatingThreadIdState';

/**
 * Self-contained animated thread name component.
 * Automatically shows typewriter animation when this thread's title
 * is generated, otherwise displays static text.
 */
interface AnimatedThreadNameProps {
    threadId?: string;
    name?: string;
    className?: string;
    fallback?: React.ReactNode;
}

export function AnimatedThreadName({
    threadId,
    name,
    className,
    fallback
}: AnimatedThreadNameProps) {
    const [animatingThreadId, setAnimatingThreadId] = useRecoilState(
        animatingThreadIdState
    );
    const isAnimating = threadId && animatingThreadId === threadId;

    if (!name) {
        return <>{fallback ?? null}</>;
    }

    return isAnimating ? (
        <TypewriterText
            text={name}
            speed={25}
            className={className}
            onComplete={() => setAnimatingThreadId(null)}
        />
    ) : (
        <span className={className}>{name}</span>
    );
}
